import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectClosedLateForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [dataDate, setDataDate] = useState(null)
  const [startDates, setStartDates] = useState(null)
  const [endDates, setEndDates] = useState(null)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(
    schema.budgetYearStartOption.options
  )
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.budgetYearEndOption.options)

  useEffect(() => {
    if (!clearValue) {
      var today = new Date()
      setDataDate(today)
      setValue(schema.showAddress.name, '0')
      setStartDates(null)
      setEndDates(null)

      const indexOptionFromBudgetYear = schema.budgetYearEndOption.options.length - 1
      const indexOptionToBudgetYear = schema.budgetYearEndOption.options.length - 1

      setValue(
        schema.budgetYearStartOption.name,
        schema.budgetYearStartOption.options[indexOptionFromBudgetYear].value
      )
      setValue(
        schema.budgetYearEndOption.name,
        schema.budgetYearEndOption.options[indexOptionToBudgetYear].value
      )
    }
  }, [clearValue])

  useEffect(() => {
    var today = new Date()
    setDataDate(today)
  }, [])

  const handleChangeBudgetYear = (name, value) => {
    console.log(name, value)
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.budgetYearStartOption.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.budgetYearEndOption.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(
          schema.budgetYearStartOption.options.filter((e) => e.value <= value)
        )
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(schema.budgetYearStartOption.options)
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options)
      }
    }
  }

  return (
    <>
      <Form>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.dataDate.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.dataDate.name]} />
            <Controller
              key={schema.dataDate.name}
              name={schema.dataDate.name}
              control={control}
              defaultValue={
                schema.dataDate.value
                  ? moment(schema.dataDate.value, DATE_PICKER_FORMAT).toDate()
                  : null
              }
              // rules={isValidators(schema.dataDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={dataDate}
                    onChange={(value) => {
                      const date = moment(value).format(DATE_PICKER_FORMAT)
                      props.onChange(value)
                      setDataDate(value)
                    }}
                    // disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.showAddress.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors.showAddress} />
            <Controller
              name={schema.showAddress.name}
              control={control}
              defaultValue={schema.showAddress.value || '0'}
              // rule={register(isValidators(schema.showAddress.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.showAddress.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.showAddress?.options &&
                      schema.showAddress.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {schema?.projectStartDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectStartDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectStartDate.name]} />
                <Controller
                  key={schema.projectStartDate.name}
                  name={schema.projectStartDate.name}
                  control={control}
                  defaultValue={
                    schema.projectStartDate.value
                      ? moment(schema.projectStartDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={startDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setStartDates(value)
                        }}
                        disabledDate={(date) =>
                          endDates && moment(endDates).isBefore(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.projectEndDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectEndDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectEndDate.name]} />
                <Controller
                  key={schema.projectEndDate.name}
                  name={schema.projectEndDate.name}
                  control={control}
                  defaultValue={
                    schema.projectEndDate.value
                      ? moment(schema.projectEndDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={endDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setEndDates(value)
                        }}
                        disabledDate={(date) =>
                          startDates && moment(startDates).isAfter(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          {schema?.budgetYearStartOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearStartOption.validators,
                  schema.budgetYearStartOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearStartOption.name]} />
                <Controller
                  name={schema.budgetYearStartOption.name}
                  control={control}
                  defaultValue={
                    fromBudgetYearOptions
                      ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearStartOption.value
                  }
                  // rules={isValidators(schema.fromBudgetYear.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={fromBudgetYearOptions}
                        // disabled={disabledValue.fromBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearStartOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.budgetYearEndOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearEndOption.validators,
                  schema.budgetYearEndOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearEndOption.name]} />
                <Controller
                  name={schema.budgetYearEndOption.name}
                  control={control}
                  defaultValue={
                    toBudgetYearOptions
                      ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearEndOption.value
                  }
                  // rules={isValidators(schema.budgetYearEndOption.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={toBudgetYearOptions}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearEndOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearStartOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        {schema.projectDepartment && (
          <>
            <Row>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectDepartment.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectDepartment.name]} />
                <Controller
                  name={schema.projectDepartment.name}
                  control={control}
                  defaultValue={schema.projectDepartment.value}
                  // rules={isValidators(schema.projectDepartment.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.projectDepartment.options}
                        // disabled={disabledValue.constYear}
                        value={props.value}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          // onChangeMainProject(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              ></Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}></Col>
            </Row>
          </>
        )}
      </Form>
    </>
  )
}
